
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Component, Vue } from "vue-property-decorator";
import NR, { CV, Ats, NRClientType } from "@/lib//model/NRXQ/nr";
import Auth from "@/lib/common/auth";
import vuexStore from "@/store/vuex-store";
import AtsTable from "@/views/nr/components/ats-candidate-table.vue";
import AtsCv from "@/views/nr/components/ats-cv.vue";
import MultiUploadCv from "@/views/nr/components/multi-upload-cv.vue";
import Model from "@/lib/model/model";

class FormData extends Model {
  name = "";
}
class Company extends Model {
  name = "";
  atsCompanyId = 0;
  atsCompanyOutId = "";
  isClose = 0;
}

@Component({
  components: { AtsTable, AtsCv, MultiUploadCv }
})
export default class CustomList extends Vue {
  nrToken = "";
  data: any = {}; //表格所有数据
  tableData: any[] = []; //表格list数据
  page = 1;
  pageSize = 10;
  companyId = "";
  search = { name: "", status: 0 };
  showAdd = false;
  formData = new FormData();
  isEdit = false;
  atsCompanyId = "";
  searchName = "";
  searchPosition = "";
  cvStatusList: number[] = []; //0初筛 10面试
  recommendStatusList: number[] = []; //0 未设置 10推荐 20不推荐
  cvId = 0;
  showCV = false;
  showMultiAdd = false;
  rules = {
    name: [{ required: true, message: "请输入客户名称", trigger: "blur" }]
  };
  clientType = NRClientType.NRClientTypeAdmin;
  selectCompanyIdList: number[] = []; //下拉选择用
  searchCompanyName = "";
  allCompanyList: Company[] = [];
  debounce = 0;

  get dc() {
    return this.data.numberCount || {};
  }

  created() {
    this.nrToken = String(localStorage.getItem("nrToken") || "");
    this.companyId = Auth.companyId;
    this.getAllCompany();
    this.getList();
  }
  mounted() {
    //
  }
  //下拉所有公司
  async getAllCompany() {
    await Ats.getAtsCompanyList({
      returnAll: true
    }).then(res => {
      for (let item of res.list) {
        const t = new Company();
        item = t.assign(item);
      }
      this.allCompanyList = res.list;
    });
  }
  get companyFilter() {
    if (this.searchCompanyName) {
      const t =
        this.allCompanyList?.filter((d: Company) =>
          d.name.includes(this.searchCompanyName)
        ) || [];
      return [...t];
    } else {
      return this.allCompanyList || [];
    }
  }

  showAddDropdown(event: string) {
    if (event == "showAddOne") {
      this.cvId = 0;
      this.showCV = true;
    } else if (event === "showAddMore") {
      this.showMultiAdd = true;
    }
  }

  async getList(flag?: string) {
    if (flag === "toPageOne") {
      this.page = 1;
    }
    //条件
    switch (this.search.status) {
      //初筛
      case 0:
        this.cvStatusList = [0];
        this.recommendStatusList = [0];
        break;
      //面试
      case 1:
        this.cvStatusList = [10];
        this.recommendStatusList = [0];
        break;
      //推荐
      case 2:
        this.cvStatusList = [0, 10];
        this.recommendStatusList = [10];
        break;
      //不推荐
      case 3:
        this.cvStatusList = [0, 10];
        this.recommendStatusList = [20];
        break;
    }
    await Ats.getCandidateList({
      page: this.page,
      pageSize: this.pageSize,
      showNameOrPhone: this.searchName,
      position: this.searchPosition,
      cvStatusList: this.cvStatusList,
      recommendStatusList: this.recommendStatusList,
      companyId: this.companyId,
      atsCompanyIdList: this.selectCompanyIdList //公司筛选
    }).then(res => {
      this.data = res;
      this.tableData = this.data.list;
    });
  }

  //新增
  add() {
    this.cvId = 0;
    this.showCV = true;
  }

  //查看
  showDetail(row: any) {
    console.log(row);
    this.atsCompanyId = row.atsCompanyId;
    this.cvId = row.atsCvId;
    this.showCV = true;
  }

  closeCv() {
    this.showCV = false;
    this.getList();
  }
  closeMultiCv() {
    this.showMultiAdd = false;
    this.getList();
  }

  debounceSearch(during = 300) {
    if (this.debounce) {
      clearTimeout(this.debounce);
    }
    this.debounce = setTimeout(() => {
      this.getList("toPageOne");
    }, during);
  }
  beforeDestroy() {
    if (this.debounce) {
      clearTimeout(this.debounce);
    }
  }
}
